export const DEFAULT_LOCAL_HOST = 'http://localhost:3000';
export const AUTH0_ACCESS_TOKEN_ENDPOINT = '/api/authtoken';
export const USER_TOKEN_TIMEOUT_MS = process.env
  .NEXT_PUBLIC_USER_TOKEN_TIMEOUT_MS
  ? Number(process.env.NEXT_PUBLIC_USER_TOKEN_TIMEOUT_MS)
  : 5_000;
export const DEFAULT_REQUEST_TIMEOUT_MS = process.env
  .NEXT_PUBLIC_MAX_REQUEST_TIMEOUT_MS
  ? Number(process.env.NEXT_PUBLIC_MAX_REQUEST_TIMEOUT_MS)
  : 15_000;
export const TOKEN_EXPIRY_LEEWAY_SECONDS = 60;
export const KV_NAMESPACE = 'cookie-';
export const MAX_LOG_ATTRIBUTE_LENGTH = 4_096;
export const REDACTED_LOG_VALUE = '[REDACTED]';

export const DEFAULT_JSON_HEADERS = {
  Accept: 'application/json',
  'Content-Type': 'application/json',
} as const;

export const SECONDS_TO_MILLISECONDS = 1_000;

export const DEFAULT_SENSITIVE_HEADER_NAMES = [
  'authorization',
  'cookie',
  'set-cookie',
  'x-api-key',
  'x-auth-token',
  'x-middleware-set-cookie',
] as const;

export const DEFAULT_SENSITIVE_JSON_KEYS = [
  'password',
  'password_confirmation',
  'passwd',
  'pwd',
  'secret',
  'client_secret',
  'token',
  'access_token',
  'refresh_token',
  'id_token',
  'api_key',
  'apikey',
  'api_secret',
  'authorization',
  'auth',
  'cookie',
  'session_id',
  'sessionid',
  'csrf',
  'csrf_token',
  'private_key',
  'privatekey',
  'ssn',
  'social_security',
  'social_security_number',
  'credit_card',
  'creditcard',
  'card_number',
  'cvv',
  'account_number',
  'routing_number',
  'iban',
  'swift',
  'tax_id',
  'tin',
  'date_of_birth',
  'dob',
  'birthdate',
  'pin',
  'security_answer',
  'security_question',
  'mothers_maiden_name',
  'identification_number',
] as const;
